import { SegmentedControl } from '@mantine/core';
import { useNavigate } from 'react-router-dom';
// utils
import { PATHS } from '@/const';
import { cn } from '@/utils';

interface NavigationProps {
    className?: string;
    value: 'customer' | 'personas' | 'projects';
}

const Navigation = ({ className, value }: NavigationProps) => {
    const navigate = useNavigate();
    const handleChange = (page: string) => {
        navigate(`${PATHS.attributes.root}/${page}`);
    };
    return (
        <SegmentedControl
            className={cn('overflow-visible', className)}
            data={[
                { value: 'customer', label: 'Customer' },
                { value: 'projects', label: 'Projects' },
                { value: 'personas', label: 'Personas' }
            ]}
            value={value}
            onChange={handleChange}
        />
    );
};

export default Navigation;
